import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CarregandoComponent } from './carregando.component';
import { NavegacaoService } from './navegacao.service';

/**
 * Sinaliza navegações demoradas (guards, lazy loading), como a busca de
 * `servicos/corporativo` e `servicos/privado` antes de abrir o login.
 *
 * - Barra fina no topo em qualquer navegação demorada.
 * - Na primeira carga (tela ainda em branco), também exibe o spinner central.
 */
@Component({
  selector: 'app-navegacao-carregando',
  standalone: true,
  imports: [NgIf, CarregandoComponent],
  templateUrl: './navegacao-carregando.component.html',
  styleUrls: ['./navegacao-carregando.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavegacaoCarregandoComponent {
  readonly navegacao = inject(NavegacaoService);
}
